export default "__VITE_ASSET__DIREHjTg__"